export class MainService {
  public async getUrl(url: string, options?: Record<string, any>): Promise<any> {
    return fetch(`${url}`, { method: 'GET', headers: { ...options } }).then(async response => {
      return await response.json();
    });
  }

  public async getKenticoBanner(kenticoUrl: string, hostUrl: string, bannerUrl: string, culture: string): Promise<any> {
    const url = `${kenticoUrl}/gmapi/Site/AppBanners?route=${bannerUrl.toLowerCase()}&host=${hostUrl}&lang=${culture}`;
    return fetch(url, { method: 'GET' }).then(async response => {
      return await response.json();
    });
  }
}
